import Axios from "axios";

export const refreshAccessToken = async () => {
    try {
        // let url = 'https://live.englishhub.app/api/v1/user/refresh-token/'
        let url = 'https://edev.englishhub.app/api/v1/user/refresh-token/'
        const refreshToken = localStorage.getItem('refresh');
        const res = await Axios.post(url, { refresh: refreshToken });
        localStorage.setItem('token',res.data.access);
        localStorage.setItem('refresh',res.data.refresh);
        window.location.reload();
    } catch (e) {
        window.location.href = "/";
        localStorage.clear();
    }

}
